export const checkFlag = (flagName: any, flagsList: any) => {
  if (!flagsList || flagsList.length === 0) {
    return;
  }
  let flag = flagsList.find((flag: any) => {
    return flagName === flag.flagName;
  });
  return flag?.flagStatus === 1 ? true : false;
};
